import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'priceName',
    standalone: false
})
export class PriceNamePipe implements PipeTransform {

  transform(number: any, multiplyThousand: boolean = true) {
    if (multiplyThousand)
      number = number * 1000;
    const mad = [' ₽', ' тыс.', ' млн.', ' млрд.', ' трлн.'];
    let word = '';

    for (let i = 0; i < mad.length; i++) {
      const tempNumber = number % (1000 * Math.pow(1000, i));
      if (Math.floor(tempNumber / Math.pow(1000, i)) !== 0) {
        word = Math.floor(tempNumber / Math.pow(1000, i)) + mad[i] + ' ' + word;
      }
    }
    return word;
  }

}
